module.exports = __webpack_public_path__ + "static/media/orange.d8f9f566.png";